import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CreateNewTemplateV2Lazy = React.lazy(
	() => import(/* webpackChunkName: 'CreateNewTemplateV2' */ './components')
);

// eslint-disable-next-line no-unused-vars
export default (_store) => {
	return {
		path: 'report-configure/report-templates/:campusId/create',
		element: (
			<AsyncLoading
				component={
					<CreateNewTemplateV2Lazy permission="CanConfigureProgressReportsTemplates" />
				}
			/>
		),
		children: [],
	};
};
